import { NBSP } from '../../../constants/symbols';

export const DEFAULT_TITLE = 'Заявка отправлена!';
export const DEFAULT_HELPER_TEXT =
  'Теперь ваша заявка доступна риелторам, которые сотрудничают с Циан. В ближайшее время они с вами свяжутся.';

export const DEFAULT_TITLE_WITHOUT_CHAT = 'Заявка отправлена';
export const DEFAULT_TEXT_WITHOUT_CHAT = 'Риелторы скоро вам перезвонят';

export const TITLE_WITH_OPENED_CHAT = `Заявка отправлена`;

export const HELPER_TEXT_WITH_CREATED_CHAT = `Переходим в${NBSP}чат — если${NBSP}он${NBSP}не${NBSP}откроется, появится${NBSP}кнопка`;

export const TITLE_WITH_CREATED_CHAT = `Заявка отправлена`;
